<template>
  <div>
    <div class="i-layout-page-header">
      <PageHeader :title="$route.meta.title" :content="$route.meta.description" hidden-breadcrumb />
    </div>
    <Card :bordered="false" dis-hover class="ivu-mt">
      <view-table ref="table" view-code="TodoList">
        <template slot-scope="{ row }" slot="command">
          <Button size="small" :title="$t('Front_Btn_Detail')" type="info" custom-icon="fa fa-file-alt" @click="$refs.taskForm.open(row)"></Button>
        </template>
      </view-table>
    </Card>
    <task-form ref="taskForm" @on-after-action="$refs.table.loadData()"></task-form>
  </div>
</template>
<script>
  import mixinPage from '../../mixins/page';
  import taskForm from './task-form';

  export default {
    name: 'common-myTask',
    mixins: [mixinPage],
    components: { taskForm },
    data() {
      return {};
    },
    computed: {},
    created() {},
    methods: {}
  };
</script>
